/* eslint-disable no-plusplus */
/**
 * Convierte un arreglo a un arbol
 *
 * Complejidad: O(n)
 * @param {Object[]} arraySource - Arreglo base que se convertirá en árbol.
 * @param {string} [parentPropName='clave_padre_id'] - Propiedad que indica la relación padre-hijo.
 *
 * @returns {Object[]} Array en forma de árbol.
 * @example
 * const baseArray = [
 *   { id: 1, parent_id: null, name: 'root' },
 *   { id: 2, parent_id: 1, name: 'child A' },
 *   { id: 3, parent_id: 1, name: 'child B' }
 * ];
 *
 * const tree = makeTree(data, 'parent_id_name_prop');
 */
const makeTree = (arraySource, parentPropName = 'clave_padre_id') => {
  const data = [...arraySource].sort((a, b) => a.id - b.id);
  const parents = [];
  const children = {};

  for (let i = 0; i < data.length; i++) {
    const item = data[i];

    // 🚫 Evitar autorreferencias
    if (item[parentPropName] === item.id) {
      /* eslint-disable no-continue */
      continue;
    }

    if (!item[parentPropName]) {
      parents.push(item);
    }

    item.children = [];

    if (item[parentPropName]) {
      if (children[item[parentPropName]]) {
        children[item[parentPropName]].push(item);
      } else {
        children[item[parentPropName]] = [item];
      }
    }
  }

  for (let i = 0; i < data.length; i++) {
    if (children[data[i].id]) {
      data[i].children = children[data[i].id];
    }
  }

  return parents;
};

export default makeTree;
